module.exports = __webpack_public_path__ + "img/ES柜.b09c787e.jpg";